import { Tabs } from "@material-ui/core";
import styled from "styled-components";

export const CustomTabs = styled(Tabs)`
  max-width: 500px;
`;
export const TabPanelContent = styled.div`
  padding: 12px;
`;
